// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import enemy from "./enemy";
import battleMode from "../battleMode";
import physics_tool from "../../../engines/libs/physics_tool";
import CSubObHurtEnemy from "../../../WsSdk/webSocketProtocol/onlineBattleList/CSubObHurtEnemy";

const { ccclass, property } = cc._decorator;

@ccclass
export default class bullet extends cc.Component {

    @property(cc.Sprite)
    spIcon: cc.Sprite = null;
    @property([cc.SpriteFrame])
    spfIcon: cc.SpriteFrame[] = [];

    // onLoad () {}

    protected start() {

    }

    private m_gameMode: battleMode = null;
    private m_seat: number;
    private m_icon: number;

    bindData(seat: number, game: battleMode, icon: number, pos?: number) {
        this.m_seat = seat;
        this.m_gameMode = game;
        this.m_icon = icon;
        this.spIcon.spriteFrame = this.spfIcon[icon];
        //
        if (icon == 2) {
            let rigid = this.node.getComponent(cc.RigidBody);
            rigid = physics_tool.setRigidBodyLinearVelocity(rigid, cc.v2(-490 + 70 * pos, 2200));
        } else {
            let rigid = this.node.getComponent(cc.RigidBody);
            rigid = physics_tool.setRigidBodyLinearVelocity(rigid, cc.v2(0, 1100));
        }
    }

    protected onShowBombEffect(selfCollider: cc.PhysicsCollider, otherCollider: cc.PhysicsCollider) {
        let sP = selfCollider.node.getPosition();
        let oP = otherCollider.node.getPosition();
        const pos = cc.v2((sP.x + oP.x) / 2, (sP.y + oP.y) / 2);
        this.m_gameMode.addBomb(pos);
    }

    onBeginContact(contact: cc.PhysicsContact, selfCollider: cc.PhysicsCollider, otherCollider: cc.PhysicsCollider) {
        // 只在两个碰撞体开始接触时被调用一次
        if (selfCollider.tag == otherCollider.tag) {
            return;
        }
        switch (otherCollider.tag) {
            //地图边界
            case 0: {
                this.m_gameMode.destroyBullet(this.node);
                break;
            }
            //自己
            case 1: {
                break;
            }
            //敌人
            case 2: {
                const hurt = 1;
                this.m_gameMode.destroyBullet(this.node);
                //只发送自己的子弹消息
                if (this.m_seat == this.m_gameMode.getSeatId()) {
                    const pack = new CSubObHurtEnemy(otherCollider.node.getComponent(enemy).getEid(), hurt);
                    this.m_gameMode.sendGameMessage(pack.getPackageBody(this.m_gameMode.gameId));
                }
                this.onShowBombEffect(selfCollider, otherCollider);
                break;
            }
            //友军或自己
            case 3: {
                break;
            }
        }
    }
}
